var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 20.0002H49.333C50.7475 20.0002 52.1041 20.5621 53.1042 21.5623C54.1044 22.5625 54.6663 23.919 54.6663 25.3335V54.6668L43.9997 44.0002H27.9997C26.5852 44.0002 25.2286 43.4383 24.2284 42.4381C23.2282 41.4379 22.6663 40.0813 22.6663 38.6668V36.0002M33.333 20.0002C33.333 21.4147 32.7711 22.7712 31.7709 23.7714C30.7707 24.7716 29.4142 25.3335 27.9997 25.3335H11.9997L1.33301 36.0002V6.66683C1.33301 5.25234 1.89491 3.89579 2.8951 2.89559C3.8953 1.8954 5.25185 1.3335 6.66634 1.3335H27.9997C29.4142 1.3335 30.7707 1.8954 31.7709 2.89559C32.7711 3.89579 33.333 5.25234 33.333 6.66683V20.0002Z",
    stroke: "#6D33FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9997 20.0002H49.333C50.7475 20.0002 52.1041 20.5621 53.1042 21.5623C54.1044 22.5625 54.6663 23.919 54.6663 25.3335V54.6668L43.9997 44.0002H27.9997C26.5852 44.0002 25.2286 43.4383 24.2284 42.4381C23.2282 41.4379 22.6663 40.0813 22.6663 38.6668V36.0002M33.333 20.0002C33.333 21.4147 32.7711 22.7712 31.7709 23.7714C30.7707 24.7716 29.4142 25.3335 27.9997 25.3335H11.9997L1.33301 36.0002V6.66683C1.33301 5.25234 1.89491 3.89579 2.8951 2.89559C3.8953 1.8954 5.25185 1.3335 6.66634 1.3335H27.9997C29.4142 1.3335 30.7707 1.8954 31.7709 2.89559C32.7711 3.89579 33.333 5.25234 33.333 6.66683V20.0002Z",
    stroke: "url(#paint0_linear_49096_424)",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_49096_424",
    x1: -2.20205,
    y1: 12.1886,
    x2: 56.8413,
    y2: 43.7204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquare);
export default __webpack_public_path__ + "static/media/message-square.d06e0aed59712ea7e7a9fd20bfbbd654.svg";
export { ForwardRef as ReactComponent };